'use strict';

import Chart from "chart.js";
import Scroll from "smooth-scroll";

// ES6 class definition
export default class Entsparrechner {

  logContants() {

    let self = this;

    // console.log(self.M);
    // console.log(self.DAX);
    // console.log(self.REXP);
    // console.log(self.EURIBOR);
    // console.log(self.MSCIWORLD);
    // console.log(self.GLOBALBONDS);
    // console.log(self.INFLATION);

  }

  constructor() {



    this.options = {
      submitButton: 'calculate',
      years: 'calculatorYears',
      balance: 'calculatorBalance',
      spend: 'calculatorSpend',
      restwert: 'calculatorRestwert',
      taxtransfer: 'calculatorTaxtransfer',
      costs: 'calculatorCosts',
      taxrate: 'calculatorTaxrate',
      allocate: 'noUi-handle'
    };

    this.values = {};

    this.submited = false;

    let self = this;

    // Statischer Input
    self.M = 10000;

    self.DAX = [-0.3018222439, 0.3278700000, 0.3483021681, -0.2190273519, 0.1285553879, -0.0208684521, 0.4670593185,
      -0.0706319375, 0.0699237627, 0.2816520844, 0.4711478213, 0.1771188016, 0.3710246502, -0.0703225242,
      -0.1985351547, -0.4444720580, 0.3941920553, 0.0749002635, 0.2802782074, 0.2150000275, 0.2104973670,
      -0.3995423729, 0.2478254542, 0.1519253485, -0.1469210421, 0.2979697712, 0.2476893577, 0.0265269845,
      0.0956050400, 0.0687004852, 0.1251260772, -0.1825937246, 0.2548000000, 0.0355000000, 0.1579000000, -0.1235000000
    ];

    self.REXP = [0.0681478317, 0.0495000000, 0.0161029061, 0.0140660165, 0.1117070464, 0.1340958243, 0.1466322676,
      -0.0251321234, 0.1668984300, 0.0754436572, 0.0656159333, 0.1124184520, -0.0194470223, 0.0685644275,
      0.0562341219, 0.0901840899, 0.0408934273, 0.0670105084, 0.0408115772, 0.0026660156, 0.0251535112,
      0.1014399114, 0.0492471857, 0.0400670891, 0.0829190877, 0.0463993627, -0.0048552736, 0.0709969140,
      0.0051288431, 0.0233414733, -0.0095406823, 0.0145647529, 0.0114000000, 0.0122000000, -0.0169000000, -0.1187000000
    ];

    self.EURIBOR = [0.0296583333, 0.0439166667, 0.0426166667, 0.0331833333, 0.0233333333, 0.0210666667, 0.0218583333,
      0.0307916667, 0.0427833333, 0.0463416667, 0.0122833333, 0.0081083333, 0.0139250000, 0.0057333333,
      0.0022000000, 0.0021000000, -0.0002000000, -0.0026416667, -0.0033000000, -0.0032333333, -0.0036000000,
      -0.0043000000, -0.0055000000, 0.0340000000
    ];

    self.MSCIWORLD = [-0.0486937246, 0.3872723911, 0.1124210588, -0.2666563109, 0.200052478, 0.0122960335, 0.3132521934,
      -0.0621407757, 0.1147680055, 0.2218746644, 0.3506364389, 0.1517358779, 0.4637525532, -0.073105306,
      -0.122986626, -0.320241871, 0.1073944693, 0.0645829075, 0.2616517298, 0.0740058358, -0.0165892808,
      -0.3764147044, 0.2593899924, 0.1952752384, -0.0238242242, 0.1404720217, 0.2120198978, 0.194962823,
      0.1042216354, 0.1072567492, 0.0751357745, -0.0410749891, 0.3002000000, 0.0633000000, 0.3107000000, -0.1278000000
    ];

    self.GLOBALBONDS = [0.1772860292, 0.1300243389, 0.1908117307, -0.1053872598, 0.1049940517, 0.1295997833, 0.2108619376,
      0.0532702479, 0.1110055117, 0.1014779361, 0.0710111892, -0.011315134, -0.063944886, 0.0140001321,
      0.100661352, -0.0461042928, -0.0125762591, 0.102165032, 0.0360077479, 0.1287574034, 0.091747353,
      0.02716665, -0.0680798093, 0.1454195859, 0.0787911582, 0.0513885809, -0.0566679662, 0.0378298811,
      0.0880000000, 0.0018000000, 0.0253000000, -0.1076000000
    ];

    self.INFLATION = [0.000249688, 0.00124533, 0.002829028, 0.002631579, 0.003729604, 0.005038168, 0.004505814,
      0.002642559, 0.001761518, 0.001331558, 0.001971091, 0.000902062, 0.00063857, 0.001395939, 0.002002503, 
      0.001349693, 0.001089588, 0.001676647, 0.001531213, 0.00162413, 0.002283105, 0.002566964, 0.000326442, 
      0.001084599, 0.002145923, 0.001995798, 0.001441813, 0.001015228, 0.000502513, 0.0005, 0.001492537, 
      0.001764706, 0.001445087, 0.000474834, 0.003119093, 0.068865179
    ];


    self.exitCalculate = false;

  }

  main() {

    let self = this;
    if (!document.querySelector('.retirement-calculator')) {
      return false;
    }
    self.submitEventListener();

  }

  calculator() {
    // Rechner

    let self = this;
    const ANTEIL_A = self.values.first / 100;
    const ANTEIL_R = self.values.second / 100;
    const ANTEIL_G = self.values.third / 100;
    const KOSTEN = self.values.costs / 100;
    const TAXRATE = self.values.taxrate / 100;

    if (self.values.investment == 'MSCI') {
      self.PERF_A = self.MSCIWORLD;
      self.PERF_R = self.REXP;
    } else if (self.values.investment == 'DAX') {
      self.PERF_A = self.DAX;
      self.PERF_R = self.GLOBALBONDS;
    } else {
      self.exitCalculate = true;
    }

    self.PERF_G = self.EURIBOR;

    let simulation = self.rechenwerk(
      self.M,
      self.values.years,
      self.values.balance,
      self.values.spend,
      self.values.restwert,
      ANTEIL_A,
      ANTEIL_R,
      ANTEIL_G,
      self.PERF_A,
      self.PERF_R,
      self.PERF_G,
      self.INFLATION,
      KOSTEN,
      TAXRATE,
      self.values.taxtransfer
    );

    // --------------------------------------------------------------------------------------------------------------------

    // Berechnung der Ausgabevariablen

    let perzentile = [];
    let anteil_positiv = simulation[self.M];
    let kapital = simulation;
    let kapital_sortiert;

    for (let x = 0; x < self.values.years; x++) {

      kapital_sortiert = [];

      for (let y = 0; y < self.M; y++) {

        kapital_sortiert[y] = kapital[y][x];

      }

      kapital_sortiert = self.sortieren(kapital_sortiert);

      for (let perzentileKeys = 0; perzentileKeys < 7; perzentileKeys++) {
        if (typeof perzentile[perzentileKeys] === "undefined") {
          perzentile[perzentileKeys] = [];
        }
      }


      perzentile[0][x] = kapital_sortiert[Math.ceil(self.M * 0.025 - 1)];
      perzentile[1][x] = kapital_sortiert[Math.ceil(self.M * 0.125 - 1)];
      perzentile[2][x] = kapital_sortiert[Math.ceil(self.M * 0.25 - 1)];
      perzentile[3][x] = kapital_sortiert[Math.ceil(self.M * 0.5 - 1)];
      perzentile[4][x] = kapital_sortiert[Math.ceil(self.M * 0.75 - 1)];
      perzentile[5][x] = kapital_sortiert[Math.ceil(self.M * 0.875 - 1)];
      perzentile[6][x] = kapital_sortiert[Math.ceil(self.M * 0.975 - 1)];

    }

    // add balance value in the first position of perzentile
    for (let x = 0; x < perzentile.length; x++) {
      perzentile[x].unshift(self.values.balance);
    }

    // Ausgabe

    // Bemerkung: Die Variablen "anteil_positiv" und "perzentile" enthalten die notwendigen Daten für die grafische Darstellung
    // analog des Vanguard-Rechners (https://retirementplans.vanguard.com/VGApp/pe/pubeducation/calculators/RetirementNestEggCalc.jsf)


    let alertMsg = '';

    alertMsg += "Die Wahrscheinlichkeit, dass Sie Ihr Ziel erreichen, beträgt " + Math.round(anteil_positiv[self.values.years - 1]) + " Prozent.";

    alertMsg += "\n\n" + "Der Wert Ihrer Ersparnisse beträgt nach " + self.values.years + " Jahren mit einer Wahrscheinlichkeit von 75 Prozent " +
      "mehr als " + Math.round(perzentile[2][self.values.years - 1]) + " Euro, mit einer Wahrscheinlichkeit von 50 Prozent mehr als " +
      Math.round(perzentile[3][self.values.years - 1]) + " Euro (in heutigen Preisen).";

    //console.log(perzentile);
    //console.log(anteil_positiv);
    //console.log(self);
    //alert(alertMsg);

    self.chartStackedArea(perzentile, self.values.spend, self.values.years, anteil_positiv[anteil_positiv.length - 1]);

    let scroll = new Scroll();
    let anchor = document.getElementById('more-details-2'); // init anchor
    scroll.animateScroll(anchor, anchor, {
      speed: 2000,
      speedAsDuration: true,
      offset: 80,
      updateURL: false
    }); // active animate scrolling

  }

  submitEventListener() {
    let self = this;
    let elem = document.getElementById(self.options.submitButton);
    elem.addEventListener('click', function (event) {
      // Don't follow the link
      event.preventDefault();

      self.values.years = parseInt(document.getElementById(self.options.years).getAttribute('aria-valuenow'));
      self.values.balance = parseInt(document.getElementById(self.options.balance).getAttribute('aria-valuenow'));
      self.values.spend = parseInt(document.getElementById(self.options.spend).getAttribute('aria-valuenow'));
      self.values.restwert = parseInt(document.getElementById(self.options.restwert).getAttribute('aria-valuenow'));
      self.values.taxtransfer = parseInt(document.getElementById(self.options.taxtransfer).getAttribute('aria-valuenow'));
      self.values.costs = parseFloat(document.getElementById(self.options.costs).getAttribute('aria-valuenow'));
      self.values.taxrate = parseInt(document.getElementById(self.options.taxrate).getAttribute('aria-valuenow'));

      let allocate = document.getElementsByClassName(self.options.allocate);
      let notes = [];

      for (let i = 0; i < allocate.length; i++) {
        notes[i] = parseInt(allocate[i].getAttribute('aria-valuenow'));
      }

      self.values.first = notes[0];
      self.values.second = notes[1] - notes[0];
      self.values.third = 100 - notes[1];

      let investments = document.getElementsByName('investment');
      for (let i = 0, length = investments.length; i < length; i++) {
        if (investments[i].checked) {
          self.values.investment = investments[i].value;
          break;
        }
      }

      self.calculator();
    }, false);
  }

  // --------------------------------------------------------------------------------------------------------------------

  eingabeOptionen(aufforderung, optionen) {

    let self = this;


    if (!self.exitCalculate) {

      let gueltig = false;
      let eingabe = '';

      let definedProperties = [];

      for (let option in optionen) {

        definedProperties.push(option);

        aufforderung += "\n" + option + " = " + optionen[option];
      }

      while (gueltig == false) {


        eingabe = prompt(aufforderung);

        if (eingabe != null) {

          if (definedProperties.indexOf(eingabe) != -1) {
            gueltig = true;
          }

        } else {
          gueltig = true;
          self.exitCalculate = true;
        }

      }

      return eingabe;

    } else {
      return null;
    }


  }


  eingabeInt(aufforderung, unten, oben) {
    let self = this;

    if (!self.exitCalculate) {

      let ergebnis = 0;
      let gueltig = false;
      let eingabe = '';

      while (gueltig == false) {

        eingabe = prompt(aufforderung);

        if (eingabe != null) {

          ergebnis = parseInt(eingabe);

          if (isNaN(ergebnis)) {
            alert("Bitte eine ganze Zahl eingeben");
          } else {
            if (ergebnis >= unten && ergebnis <= oben) {

              gueltig = true;

            } else {

              alert("Bitte eine Zahl zwischen " + unten + " und " + oben + " eingeben");

            }
          }
        } else {
          gueltig = true;
          self.exitCalculate = true;
        }


      }

      return ergebnis;

    } else {
      return null;
    }


  }

  // --------------------------------------------------------------------------------------------------------------------

  // Methoden (2): Eingabe double

  eingabeDouble(aufforderung, unten, oben) {

    let self = this;

    if (!self.exitCalculate) {

      let ergebnis = 0;
      let gueltig = false;
      let eingabe;

      while (gueltig == false) {

        eingabe = prompt(aufforderung);

        if (eingabe != null) {

          ergebnis = parseFloat(eingabe);

          if (!isNaN(ergebnis)) {

            if (ergebnis >= unten && ergebnis <= oben) {

              gueltig = true;

            } else {

              alert("Bitte eine Zahl zwischen " + unten + " und " + oben + " eingeben", "Fehler");

            }


          } else {

            alert("Bitte eine Gleitkommazahl eingeben");

          }

        } else {
          gueltig = true;
          self.exitCalculate = true;
        }

      }

      return ergebnis;

    } else {
      return null;
    }

  }


  // --------------------------------------------------------------------------------------------------------------------

  // Methoden (3): "Eigentlicher"	Rechner

  rechenwerk(M, JAHRE, STARTKAP, AUSGABEN, GRENZWERT,
    ANTEIL_A, ANTEIL_R, ANTEIL_G, PERF_A, PERF_R, PERF_G,
    INFLATION, KOSTEN, STEUERN, UEBERTRAG) {


    // Initialisierung (n=Jahre, m=Durchführungen)
    let self = this;
    let n = 0;
    let m = 0;

    let LEN_A = PERF_A.length;
    let LEN_R = PERF_R.length;
    let LEN_G = PERF_G.length;
    let LEN_INFL = INFLATION.length;

    let preis = [];
    let preisindex = [];
    let entsparen_n = [];
    let entsparen_b = [];
    let verluste = [];
    let stuecke = [];
    let simulation = [];

    let random_PERF_A, random_PERF_R, random_PERF_G;

    // Rechner

    while (n < JAHRE) {

      m = 0;

      // Zähler für die Anzahl positiver Jahre

      let i = 0;

      while (m < M) {


        if (typeof preis[m] === "undefined") {
          preis[m] = [];
        }
        if (typeof preisindex[m] === "undefined") {
          preisindex[m] = [];
        }
        if (typeof entsparen_b[m] === "undefined") {
          entsparen_b[m] = [];
        }
        if (typeof stuecke[m] === "undefined") {
          stuecke[m] = [];
        }
        if (typeof verluste[m] === "undefined") {
          verluste[m] = [];
        }
        if (typeof simulation[m] === "undefined") {
          simulation[m] = [];
        }


        // Erstes Jahr

        if (n == 0) {

          random_PERF_A = Math.floor(Math.random() * (LEN_A));
          random_PERF_R = Math.floor(Math.random() * (LEN_R));
          random_PERF_G = Math.floor(Math.random() * (LEN_G));

          preis[m][n] = (
            1 +
            (
              (ANTEIL_A * PERF_A[random_PERF_A]) +
              (ANTEIL_R * PERF_R[random_PERF_R]) +
              (ANTEIL_G * PERF_G[random_PERF_G]) -
              KOSTEN
            )
          );

          preisindex[m][n] = 1 + INFLATION[Math.floor(Math.random() * (LEN_INFL))];


          if (typeof entsparen_n[m] === "undefined") {
            entsparen_n[m] = [];
          }
          entsparen_n[m][n] = AUSGABEN * preisindex[m][n];

          // Fall mit Verlust

          if (preis[m][n] <= 1) {

            entsparen_b[m][n] = entsparen_n[m][n];

            if (typeof verluste[m] === "undefined") {
              verluste[m] = [];
            }
            verluste[m][n] = UEBERTRAG - (entsparen_b[m][n] / preis[m][n]) * (preis[m][n] - 1);

            stuecke[m][n] = STARTKAP - entsparen_b[m][n] / preis[m][n];

          } else {

            // Fall mit Gewinn, ohne Verlustvortrag

            if (UEBERTRAG == 0) {
              entsparen_b[m][n] = entsparen_n[m][n] / (1 + (preis[m][n] - 1) * (1 - STEUERN)) * preis[m][n];
              verluste[m][n] = 0;
              stuecke[m][n] = STARTKAP - entsparen_b[m][n] / preis[m][n];

            } else {

              // Fall mit Gewinn und Verlustvortrag, der ausreicht

              if ((entsparen_n[m][n] / preis[m][n]) * (preis[m][n] - 1) <= UEBERTRAG) {
                entsparen_b[m][n] = entsparen_n[m][n];
                verluste[m][n] = UEBERTRAG - (entsparen_b[m][n] / preis[m][n]) * (preis[m][n] - 1);
                stuecke[m][n] = STARTKAP - entsparen_b[m][n] / preis[m][n];

              } else {

                // Fall mit Gewinn und Verlustvortrag, der nicht ausreicht

                entsparen_b[m][n] = UEBERTRAG / (preis[m][n] - 1) * preis[m][n] +
                  (entsparen_n[m][n] - (UEBERTRAG / (preis[m][n] - 1) * preis[m][n])) /
                  (1 + (preis[m][n] - 1) * (1 - STEUERN)) * preis[m][n];

                if (typeof verluste[m] === "undefined") {
                  verluste[m] = [];
                }
                verluste[m][n] = 0;

                stuecke[m][n] = STARTKAP - entsparen_b[m][n] / preis[m][n];
              }

            }

          }

          // Fall, dass das Kapital aufgezehrt wird

          if (STARTKAP * preis[m][n] < entsparen_b[m][n]) {
            entsparen_b[m][n] = STARTKAP * preis[m][n];
            stuecke[m][n] = 0;

            if (preis[m][n] <= 1) {
              verluste[m][n] = UEBERTRAG - (entsparen_b[m][n] / preis[m][n]) * (preis[m][n] - 1);

            } else {

              verluste[m][n] = UEBERTRAG;

            }

          }


          // Weitere Jahre

        } else {

          preis[m][n] = preis[m][n - 1] * (1 + (ANTEIL_A * PERF_A[Math.floor(Math.random() * (LEN_A))] +
            ANTEIL_R * PERF_R[Math.floor(Math.random() * (LEN_R))] +
            ANTEIL_G * PERF_G[Math.floor(Math.random() * (LEN_G))] -
            KOSTEN));

          preisindex[m][n] = preisindex[m][n - 1] + INFLATION[Math.floor(Math.random() * (LEN_INFL))];

          entsparen_n[m][n] = AUSGABEN * preisindex[m][n];

          // Fall mit Verlust

          if (preis[m][n] <= 1) {
            entsparen_b[m][n] = entsparen_n[m][n];
            verluste[m][n] = verluste[m][n - 1] - (entsparen_b[m][n] / preis[m][n]) * (preis[m][n] - 1);
            stuecke[m][n] = stuecke[m][n - 1] - entsparen_b[m][n] / preis[m][n];

          } else {

            // Fall mit Gewinn, ohne Verlustvortrag (weitgehend wie in Jahr 1)

            if (verluste[m][n - 1] == 0) {
              entsparen_b[m][n] = entsparen_n[m][n] / (1 + (preis[m][n] - 1) * (1 - STEUERN)) * preis[m][n];
              verluste[m][n] = 0;
              stuecke[m][n] = stuecke[m][n - 1] - entsparen_b[m][n] / preis[m][n];

            } else {

              // Fall mit Gewinn und Verlustvortrag, der ausreicht

              if ((entsparen_n[m][n] / preis[m][n]) * (preis[m][n] - 1) <= verluste[m][n - 1]) {
                entsparen_b[m][n] = entsparen_n[m][n];
                verluste[m][n] = verluste[m][n - 1] - (entsparen_b[m][n] / preis[m][n]) * (preis[m][n] - 1);
                stuecke[m][n] = stuecke[m][n - 1] - entsparen_b[m][n] / preis[m][n];

              } else {

                // Fall mit Gewinn und Verlustvortrag, der nicht ausreicht

                entsparen_b[m][n] = verluste[m][n - 1] / (preis[m][n] - 1) * preis[m][n] +
                  (entsparen_n[m][n] - (verluste[m][n - 1] / (preis[m][n] - 1) * preis[m][n])) /
                  (1 + (preis[m][n] - 1) * (1 - STEUERN)) * preis[m][n];
                verluste[m][n] = 0;
                stuecke[m][n] = stuecke[m][n - 1] - entsparen_b[m][n] / preis[m][n];
              }

            }

          }

          // Fall, dass das Kapital aufgezehrt wird

          if (stuecke[m][n - 1] * preis[m][n] < entsparen_b[m][n]) {
            entsparen_b[m][n] = stuecke[m][n - 1] * preis[m][n];
            stuecke[m][n] = 0;

            if (preis[m][n] <= 1) {
              verluste[m][n] = verluste[m][n - 1] - (entsparen_b[m][n] / preis[m][n]) * (preis[m][n] - 1);

            } else {

              verluste[m][n] = verluste[m][n - 1];

            }

          }

        }


        // Berechnung der Ausgabevariablen ("ergebnis" ist stets in realen Preisen!)

        simulation[m][n] = stuecke[m][n] * preis[m][n] / preisindex[m][n];

        if (simulation[m][n] > GRENZWERT) {

          i++;

        }

        m++;

      }

      if (typeof simulation[m] === "undefined") {
        simulation[m] = [];
      }

      simulation[m][n] = i / M * 100;

      n++;

    }

    return simulation;

  }


  // --------------------------------------------------------------------------------------------------------------------

  // Methoden (4): Arraysortierung

  mischen(f1, f2) {

    let n1 = f1.length;
    let n2 = f2.length;
    let n = n1 + n2;
    let f = [];
    let i1, i2, i;
    i = 0;
    i1 = 0;
    i2 = 0;

    while (i1 < n1 & i2 < n2) {

      if (f1[i1] <= f2[i2]) {

        f[i] = f1[i1];
        i1 = i1 + 1;
        i = i + 1;

      } else {

        f[i] = f2[i2];
        i2 = i2 + 1;
        i = i + 1;

      }

    }

    if (i1 == n1) {

      while (i2 < n2) {

        f[i] = f2[i2];
        i2 = i2 + 1;
        i = i + 1;

      }

    }

    if (i2 == n2) {

      while (i1 < n1) {

        f[i] = f1[i1];
        i1 = i1 + 1;
        i = i + 1;

      }

    }

    return f;

  }


  // --------------------------------------------------------------------------------------------------------------------

  // Methoden (5): Arraysortierung

  sortieren(f) {


    let self = this;

    let n = f.length;

    if (n > 1) {

      let nl = Math.round(n / 2);
      let nr = n - nl;
      let hlinks = [];
      let i = 0;

      while (i < nl) {

        hlinks[i] = f[i];
        i = i + 1;

      }

      let flinks = self.sortieren(hlinks);
      let hrechts = [];

      i = 0;

      while (i < nr) {

        hrechts[i] = f[nl + i];
        i = i + 1;

      }

      let frechts = self.sortieren(hrechts);

      return self.mischen(flinks, frechts);

    } else {
      return f;
    }

  }

  // --------------------------------------------------------------------------------------------------------------------
  // Methoden (10): Chart.js to build a stacked area

  chartStackedArea(myData, spend, years, percent) {
    let self = this;
    window.chartColors = {
      sky: 'rgb(73, 163, 229)',
      green: 'rgb(150, 190, 14)',
      blue: 'rgb(24, 78, 125)',
      gray: 'rgb(200, 200, 200)',
      gray2: 'rgb(242, 242, 242)',
      black: 'rgb(0,0,0)',
    };

    if( document.documentElement.lang == "de" ) {
      document.querySelector('.result_text_en').style.display = 'none';
    }
    else {
      document.querySelector('.result_text_de').style.display = 'none';
    }

    let labelsYears = [];
    for (let i = 0; i < myData[0].length; i++) {
      labelsYears.push(i.toString());
    }
    let round_percent = document.documentElement.lang == "de" ? self.addDecimalNumber(Math.round(percent)) : Math.round(percent);
    let percent50 = document.documentElement.lang == "de" ? self.addPointNumber( Math.round(myData[3][myData[0].length-1]) ) : self.addDecimalNumber(self.addPointNumber( Math.round(myData[3][myData[0].length-1]) ));

    document.getElementById("result_text").style.display = "block";


    let result_spend = document.querySelectorAll(".result_text_spend");
    for (let i = 0; i <result_spend.length; i++) {
      result_spend[i].innerHTML = document.documentElement.lang == "de" ? self.addPointNumber( spend ) : self.addDecimalNumber(self.addPointNumber( spend ));
    }

    let result_percent = document.querySelectorAll(".result_text_percent");
    for (let i = 0; i <result_percent.length; i++) {
      result_percent[i].innerHTML = round_percent;
    }

    let result_year = document.querySelectorAll(".result_text_years");
    for (let i = 0; i <result_year.length; i++) {
      result_year[i].innerHTML = years;
    }
    let result_percent50 = document.querySelectorAll(".result_text_percent50");
    for (let i = 0; i <result_percent50.length; i++) {
      result_percent50[i].innerHTML = percent50;
    }

    let text_v1 = document.querySelectorAll(".result_text_block1-v1");
    let text_v2 = document.querySelectorAll(".result_text_block1-v2");
    let hide_v3 =document.querySelectorAll(".result_text_block1-v3");

    if( round_percent <0.9 ) {
      for (let i = 0; i <text_v1.length; i++) {
        text_v1[i].style.display = "inline";
        text_v2[i].style.display = "none";
        hide_v3[i].style.display = "none";
      }
    }
    else if( round_percent > 1) {
      if( percent50 == 0) {
        for (let i = 0; i <text_v1.length; i++) {
          text_v1[i].style.display = "none";
          text_v2[i].style.display = "inline";
          hide_v3[i].style.display = "none";
        }
      }
      else {
        for (let i = 0; i <text_v1.length; i++) {
          text_v1[i].style.display = "none";
          text_v2[i].style.display = "none";
          hide_v3[i].style.display = "inline";
        }
      }
    }

		let config = {
      type: 'line',
      plugins:[{
        afterDraw: chart => {
          if(window.innerWidth < 767) {
            let ctx = chart.chart.ctx;
            ctx.save();
            ctx.font = "12px Arial";
            ctx.fillStyle = "gray";
            let y = 10;

            ctx.textAlign = 'left';
            ctx.fillText('Euro', 10, y);
          }
        }
      }],
			data: {
        labels: labelsYears,
				datasets: [{
					label: '12.5%',
					borderColor: window.chartColors.gray2,
          backgroundColor: window.chartColors.gray2,
          data: myData[1],
          fillStyle: '#cfcfcf',
          pointBorderColor: '#cfcfcf',
          fill: '1'
				},{
					label: '25%',
					borderColor: window.chartColors.gray,
          backgroundColor: window.chartColors.gray,
          data: myData[2],
          fillStyle: '#999',
          pointBorderColor: '#999',
          fill: '-2'
				}, {
					label: '50%',
					borderColor: window.chartColors.black,
          backgroundColor: window.chartColors.gray,
          data: myData[3],
          fillStyle: window.chartColors.black,
          pointBorderColor: '#000',
          fill: '1'
				}, {
					label: '75%',
					borderColor: window.chartColors.gray,
          backgroundColor: window.chartColors.gray,
          data: myData[4],
          fillStyle: '#999',
          pointBorderColor: '#999',
          fill: '1'
				}, {
					label: '87.5%',
					borderColor: window.chartColors.gray2,
          backgroundColor: window.chartColors.gray2,
          data: myData[5],
          fillStyle: '#cfcfcf',
          pointBorderColor: '#cfcfcf',
          fill: '-2'
				}]
			},
			options: {
        responsive: true,
        maintainAspectRatio: window.innerWidth > 767,
        aspectRatio: window.innerWidth > 767 ? 2: 1,
        layout: {
          padding: {
              left: 0,
              right: 0,
              top: window.innerWidth > 767 ? 0: 25,
              bottom: 0
          }
        },
				title: {
          display: false,
          position: 'bottom',
          padding: 20,
          fontSize: 16,
					text: document.documentElement.lang == 'de' ? 'Wahrscheinlichkeit der Entwicklung Ihrer Ersparnisse' : 'Percent of projected results within range:'
        },
        legend: {
          display: false,
          position: 'bottom',
          align: 'end',
          labels: {
            filter: function(legendItem, data) {
              return legendItem.fillStyle = legendItem.strokeStyle;
            }
          }
        },
				tooltips: {
          enabled: window.innerWidth > 767,
          mode: 'nearest',
          intersect: false,
          callbacks: {
            title: function(tooltipItems, data) {
              let xlabelText =  document.documentElement.lang == 'de' ? 'Jahre' : 'Years';
              return `${tooltipItems[0].xLabel} ${xlabelText}`;
            },
            labelColor: function(tooltipItem, chart) {
              return {
                borderColor: chart.legend.legendItems[tooltipItem.datasetIndex].fillStyle,
                backgroundColor: chart.legend.legendItems[tooltipItem.datasetIndex].fillStyle
              };
            },
            label: function(tooltipItem, data) {
                if(document.documentElement.lang == "de") {
                  return self.addPointNumber(Math.round(tooltipItem.yLabel))+'€';
                }
                else {
                  return self.addDecimalNumber(self.addPointNumber(Math.round(tooltipItem.yLabel)))+'€';
                }
              },
            },
				},
				hover: {
					mode: 'index'
        },
        elements: {
          line: {
            tension: 0.1,
            borderWidth: window.innerWidth > 767 ? 3: 1,
            pointBorderWidth: window.innerWidth > 767 ? 10: 1
          }
        },
				scales: {
					xAxes: [{
						scaleLabel: {
              display:  true,
							labelString: document.documentElement.lang == 'de' ? 'Jahre' : 'Years'
            },
            gridLines: {
              display: true,
              drawBorder: true,
              drawOnChartArea: false,
            }
					}],
					yAxes: [{
            ticks: {
              callback: function(label, index, labels) {
                if(document.documentElement.lang == "de") {
                  return self.addPointNumber( label );
                }
                else {
                  return self.addDecimalNumber(self.addPointNumber( label ));
                }

              }
            },
						scaleLabel: {
							display: window.innerWidth > 767,
							labelString: 'Euro'
            },
            gridLines: {
              display: true,
              drawBorder: true,
              drawOnChartArea: false,
            }
					}]
				}
			}
    };

    //reset chart canvas
    //remove all child
    const myNode = document.getElementById('result_graph2');
    while (myNode.firstChild) {
      myNode.removeChild(myNode.lastChild);
    }
    // create a new canvas
    let canvas = document.createElement("CANVAS");
    canvas.id = "canvas";
    myNode.appendChild(canvas); // add canvas in parent

    // draw a stacked area
    let ctx = canvas.getContext('2d');
		window.myLine = new Chart(ctx, config);
    window.myLine.update(true);

  }

  addPointNumber( myNumber ) {
    return `${myNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
  }

  addDecimalNumber( myNumber ) {
    return `${myNumber.toString().replace('.', ",")}`;
  }
}
